// Mock data for Ömer Karani Denizoglu Portfolio

export const profileData = {
  name: "Ömer Karani Denizoglu",
  title: "Software Developer",
  role: "Founder & CEO",
  companies: [
    "Karany Holding",
    "Karany Web Solutions B.V."
  ],
  location: "Netherlands",
  email: "software@karany.com",
  available: true
};

export const socialLinks = [
  {
    id: 1,
    name: "GitHub",
    username: "@karaniJS",
    url: "https://github.com/karaniJS",
    icon: "github"
  },
  {
    id: 2,
    name: "LinkedIn",
    username: "Ömer Karani Denizoglu",
    url: "https://www.linkedin.com/in/%C3%B6mer-karani-denizo%C4%9Flu-bb6047171/",
    icon: "linkedin"
  },
  {
    id: 3,
    name: "Instagram",
    username: "@karani.js",
    url: "https://www.instagram.com/karani.js/",
    icon: "instagram"
  },
  {
    id: 4,
    name: "X (Twitter)",
    username: "@karaniJS",
    url: "https://x.com/karaniJS",
    icon: "twitter"
  }
];

export const skills = [
  { name: "JavaScript", level: 95 },
  { name: "React", level: 90 },
  { name: "Node.js", level: 85 },
  { name: "TypeScript", level: 80 },
  { name: "Python", level: 75 },
  { name: "MongoDB", level: 80 },
  { name: "Git", level: 90 },
  { name: "CSS/Tailwind", level: 85 }
];

export const projects = [
  {
    id: 1,
    title: {
      en: "E-Commerce Platform",
      nl: "E-Commerce Platform",
      tr: "E-Ticaret Platformu"
    },
    description: {
      en: "A modern e-commerce platform. Developed with React, Node.js and MongoDB.",
      nl: "Een modern e-commerce platform. Ontwikkeld met React, Node.js en MongoDB.",
      tr: "Modern bir e-ticaret platformu. React, Node.js ve MongoDB ile geliştirildi."
    },
    tags: ["React", "Node.js", "MongoDB"],
    github: "https://github.com/karaniJS",
    live: "#"
  },
  {
    id: 2,
    title: {
      en: "Task Management App",
      nl: "Taakbeheer App",
      tr: "Görev Yönetim Uygulaması"
    },
    description: {
      en: "Real-time task management application developed for teams.",
      nl: "Real-time taakbeheer applicatie ontwikkeld voor teams.",
      tr: "Ekipler için geliştirilmiş real-time görev yönetim uygulaması."
    },
    tags: ["TypeScript", "Socket.io", "PostgreSQL"],
    github: "https://github.com/karaniJS",
    live: "#"
  },
  {
    id: 3,
    title: {
      en: "AI Chat Assistant",
      nl: "AI Chat Assistent",
      tr: "AI Sohbet Asistanı"
    },
    description: {
      en: "AI-powered intelligent chat assistant.",
      nl: "AI-aangedreven intelligente chat assistent.",
      tr: "Yapay zeka destekli akıllı sohbet asistanı."
    },
    tags: ["Python", "OpenAI", "FastAPI"],
    github: "https://github.com/karaniJS",
    live: "#"
  }
];
